import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AssignmentsState } from '../reducers/base-assignments.reducer';

const getAssignmentsState = createFeatureSelector<AssignmentsState>('assignments');

export const getAssignmentList = createSelector(getAssignmentsState, (state) => state.list);
export const getAssignmentListData = createSelector(getAssignmentsState, (state) => state.list.data);
export const getAllCustomerAssignments = createSelector(getAssignmentsState, (state) => state.allCustomerAssignments);
export const getCustomerAssignmentsFilters = createSelector(
  getAssignmentsState,
  (state: any) => state.allCustomerAssignments.data.filters
);
export const getDocumentView = createSelector(
  getAssignmentsState,
  (state: any): { data: Blob | undefined; fileName: string | undefined } => state.downloadDocument
);
export const getAssignmentListStatus = createSelector(getAssignmentsState, (state: any) => state.list.ok);
export const getAssignment = createSelector(getAssignmentsState, (state: any) => state.assignment);
export const getAssignmentDates = createSelector(getAssignmentsState, (state: any) => state.dates);
export const getCandidateEndedAssignments = createSelector(
  getAssignmentsState,
  (state: any) => state.candidateEndedAssignments
);
export const getCandidateReviews = createSelector(getAssignmentsState, (state: any) => state.reviews);
export const getSignContractStatus = createSelector(getAssignmentsState, (state) => state.signContractStatus.ok);
export const getAssignmentProfileIDCard = createSelector(
  getAssignmentsState,
  (
    state: any
  ): {
    data: Blob | undefined;
    fileName: string | undefined;
  } => state.assignmentProfileIDCard
);

export const getWorkCouncilComments = createSelector(getAssignmentsState, (state) => state.workCouncilComments);
export const getUpcomingEPAssignments = createSelector(getAssignmentsState, (state) => state.upcomingEPAssignments);
export const getUpcomingMLPAssignments = createSelector(getAssignmentsState, (state) => state.upcomingMLPAssignments);
export const getLocationDepartmentQualificationList = createSelector(
  getAssignmentsState,
  (state) => state.locationDepartmentQualificationList
);
export const getCustomerLocationDepartment = createSelector(
  getAssignmentsState,
  (state) => state.customerLocationDepartment
);

export const getAssignmentDateList = createSelector(getAssignmentsState, (state) => state.assignmentDateList);

export const getAssignmentDateTimestampList = createSelector(
  getAssignmentsState,
  (state) => state.assignmentDateTimestampList
);
export const getAssignmentDateTimestampListData = createSelector(
  getAssignmentsState,
  (state) => state.assignmentDateTimestampList.data
);
export const getAssignmentDateTimestamps = createSelector(
  getAssignmentsState,
  (state) => state.assignmentDateTimestampList.data?.timestamps
);
export const getAssignmentDateTimestampContext = createSelector(
  getAssignmentsState,
  (state) => state.assignmentDateTimestampList.data?.assignmentDate
);
export const getAssignmentDateTimestampListStatus = createSelector(
  getAssignmentsState,
  (state) => state.assignmentDateTimestampList.ok
);
